window.estimateShippingCalculator = window.estimateShippingCalculator || {};

(function ($) {
  "use strict";

  window.estimateShippingCalculator = {
    init() {
      $('[data-adev-estimate-shipping]:not(.adev-init)').each((index, el) => {
        const self = $(el);
        self.addClass('adev-init');

        const calculate = self.find('[data-adev-es="calculate"]');
        const countrySelect = self.find('[data-adev-es="country"]');

        countrySelect.on('change', (e) => this.handleCountryChange(e, self));
        calculate.on('click', (e) => this.handleCalculateClick(e, self));

        // Auto-déclencher le changement pour charger les provinces si un pays est déjà sélectionné
        if (countrySelect.val()) {
          countrySelect.trigger('change');
        }
      });
    },

    createOptionElement(province) {
      const option = document.createElement('option');
      option.value = province[0];
      option.innerHTML = province[1];
      return option;
    },

    populateProvinces(provinces, provinceSelect) {
      provinceSelect.empty();
      provinces.forEach((province) => {
        provinceSelect.append(this.createOptionElement(province));
      });
    },

    handleCountryChange(e, self) {
      const provinceField = self.find('[data-adev-es="province-field"]');
      const provinceSelect = self.find('[data-adev-es="province"]');

      self.find('[data-adev-es="result"]').hide();

      const selectedCountryEl = $(e.target)[0];
      const selectedOption = selectedCountryEl[selectedCountryEl.selectedIndex];
      const provinces = JSON.parse(selectedOption.dataset.provinces || '[]');

      if (!provinces.length) {
        provinceField.hide();
      } else {
        this.populateProvinces(provinces, provinceSelect);
        provinceField.show();
      }
    },

    handleCalculateClick(e, self) {
      e.preventDefault();

      const countrySelect = self.find('[data-adev-es="country"]');
      const provinceSelect = self.find('[data-adev-es="province"]');
      const zip = self.find('[data-adev-es="zip"]');
      const result = self.find('[data-adev-es="result"]');
      const calculateBtn = $(e.currentTarget);

      result.removeClass('alert-error alert-success').hide();

      const params = `shipping_address[zip]=${encodeURIComponent(zip.val())}&shipping_address[country]=${encodeURIComponent(countrySelect.val())}&shipping_address[province]=${encodeURIComponent(provinceSelect.val())}`;
      console.log('Sending shipping estimate with params:', params);

      calculateBtn.addClass('loading');

      $.ajax({
        url: `/cart/shipping_rates.json?${params}`,
        method: "GET",
        dataType: "json",
        success: (data) => {
          calculateBtn.removeClass('loading');
          this.displayShippingRates(result, data);
        },
        error: (error) => {
          calculateBtn.removeClass('loading');
          this.displayErrors(result, error.responseJSON || {});
        }
      });
    },

    displayShippingRates(element, data) {
      if (data && data.shipping_rates && Array.isArray(data.shipping_rates) && data.shipping_rates.length) {
        let rates = '';
        data.shipping_rates.forEach((rate) => {
          // Formatage du prix pour éviter la division par 100
          const formattedRate = rate.price + ' €'; 
          rates += `<li>${rate.name} : ${formattedRate}</li>`;
        });

        element
          .addClass('alert-success')
          .html(`<p>Frais de port disponibles :</p><ul class="styled-list">${rates}</ul>`)
          .show();
      } else {
        element
          .addClass('alert-success')
          .html('<p>Nous ne livrons pas cette destination.</p>')
          .show();
      }
    },

    displayErrors(element, data) {
      let errors = '';
      if (data.errors) {
        Object.keys(data.errors).forEach((key) => {
          errors += `<li>${data.errors[key]}</li>`;
        });
      } else {
        errors = '<li>Une erreur s\'est produite lors de la récupération des frais de port.</li>';
      }

      element
        .addClass('alert-error')
        .html(`<ul class="styled-list">${errors}</ul>`)
        .show();
    }
  };

  // Initialiser le calculateur d'estimation des frais de port
  document.addEventListener('adev:estimate:shipping:init', () => {
    window.estimateShippingCalculator.init();
  });

  document.dispatchEvent(new CustomEvent('adev:estimate:shipping:init'));

})(jQuery);
